"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var actions_1 = require("../../../contexts/rubyJackpot/actions");
var context_1 = require("../../../contexts/rubyJackpot/context");
var useRequests_1 = __importDefault(require("../../../hooks/useRequests"));
var constants_1 = require("./constants");
var Wrapper_1 = __importDefault(require("./containers/Wrapper/Wrapper"));
var localization_1 = require("./localization");
var appendToHead_1 = require("./utils/appendToHead");
var assetsHelper_1 = require("./utils/assetsHelper/assetsHelper");
var getNewState_1 = require("./utils/immer/getNewState");
var DURATION_MS = 3000;
var MOBILE_WIDTH = 876;
var App = function (_a) {
    var dispatcher = _a.dispatcher, features = _a.features, show_games = _a.show_games, redirectURL = _a.redirectURL, interval = _a.interval, lang = _a.lang, currency = _a.currency, testMode = _a.testMode;
    var dispatch = (0, context_1.useRubyJackpotContext)().dispatch;
    var _b = (0, useRequests_1.default)(), getFeatureState = _b.getFeatureState, getFeatureConfigs = _b.getFeatureConfigs;
    var preparedInterval = parseFloat(interval);
    var serverInterval = isFinite(preparedInterval) ? preparedInterval : DURATION_MS;
    var _c = (0, react_1.useState)({}), tickerDiff = _c[0], setTickerDiff = _c[1];
    var _d = (0, react_1.useState)(true), firstTime = _d[0], setFirstTime = _d[1];
    var initDiff = function (features) {
        var store = {};
        features.forEach(function (feature) {
            store[feature.id] = {
                prev: feature.featureData.ticker,
                startTime: feature.featureData.startTime,
                endTime: feature.featureData.endTime,
                diff: 0.01,
            };
        });
        setTickerDiff(store);
    };
    var updateDiff = function (features) {
        var store = {};
        features.forEach(function (feature) {
            if (tickerDiff[feature.id] !== undefined) {
                var next = feature.featureData.ticker;
                var prev = tickerDiff[feature.id].prev;
                var perSecond = DURATION_MS / 1000;
                var diff = parseFloat(((next - prev) / perSecond).toFixed(2));
                if (diff === 0) {
                    diff = 0.01;
                }
                if (diff > 8) {
                    diff = 0.01;
                }
                store[feature.id] = __assign(__assign({}, tickerDiff[feature.id]), { prev: next, startTime: feature.featureData.startTime, endTime: feature.featureData.endTime, diff: diff });
            }
        });
        setTickerDiff(store);
    };
    var _e = (0, react_1.useState)([]), featuresData = _e[0], setFeaturesData = _e[1];
    var _f = (0, react_1.useState)([]), localFeaturesData = _f[0], setLocalFeaturesData = _f[1];
    var setUpLocale = (0, react_1.useCallback)(function () {
        (0, localization_1.createDictionary)(lang);
    }, [lang]);
    setUpLocale();
    var handleNewFeatures = function (data) {
        var nextState = (0, getNewState_1.getNewState)(featuresData, data);
        setFeaturesData(nextState);
        updateDiff(nextState);
    };
    var updateFeatureState = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getFeatureState({ features: features, show_games: show_games, lang: lang, interval: interval, currency: currency })];
                case 1:
                    data = _a.sent();
                    handleNewFeatures(data.features);
                    dispatch((0, actions_1.setLastWinners)(data.lastWinners));
                    dispatch((0, actions_1.setShortStats)(data.shortStatistics));
                    return [2 /*return*/];
            }
        });
    }); };
    var updateLocalFeatureState = function () {
        var featureStore = [];
        localFeaturesData.forEach(function (localFeature) {
            localFeature = __assign(__assign({}, localFeature), { featureData: __assign(__assign({}, localFeature.featureData), { startTime: tickerDiff[localFeature.id].startTime, endTime: tickerDiff[localFeature.id].endTime, ticker: tickerDiff[localFeature.id] !== undefined
                        ? tickerDiff[localFeature.id].prev > localFeature.featureData.ticker
                            ? tickerDiff[localFeature.id].prev
                            : localFeature.featureData.ticker + tickerDiff[localFeature.id].diff
                        : localFeature.featureData.ticker }) });
            featureStore.push(localFeature);
        });
        setLocalFeaturesData(featureStore);
    };
    var getInitFeatures = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getFeatureConfigs({ features: features, show_games: show_games, currency: currency, lang: lang, interval: interval })];
                case 1:
                    response = _a.sent();
                    (0, appendToHead_1.appendCss)((0, assetsHelper_1.getAssetValueByKey)(response.assets, constants_1.AssetsTypes.WIDGET_CSS));
                    setFeaturesData(response.features);
                    initDiff(response.features);
                    setLocalFeaturesData(response.features);
                    dispatch((0, actions_1.setGames)(response.games));
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var intervalId = setTimeout(updateFeatureState, serverInterval);
        return function () { return clearTimeout(intervalId); };
    }, [featuresData, tickerDiff]);
    (0, react_1.useEffect)(function () {
        getInitFeatures();
    }, []);
    (0, react_1.useEffect)(function () {
        var timeout = setTimeout(function () { return updateLocalFeatureState(); }, firstTime ? 3000 : 1000);
        return function () { return clearTimeout(timeout); };
    }, [localFeaturesData]);
    (0, react_1.useEffect)(function () {
        var timeout = setTimeout(function () { return setFirstTime(false); }, 1000);
        return function () { return clearTimeout(timeout); };
    }, []);
    var handleReset = function () {
        handleNewFeatures([]);
    };
    var subscribe = function () {
        dispatcher
            .on(constants_1.DispatchEvents.SetState, handleNewFeatures, _this)
            .on(constants_1.DispatchEvents.SetFeatures, handleNewFeatures, _this)
            .on(constants_1.DispatchEvents.Reset, handleReset, _this);
    };
    var unSubscribe = function () {
        dispatcher
            .off(constants_1.DispatchEvents.SetState, handleNewFeatures, _this)
            .off(constants_1.DispatchEvents.SetFeatures, handleNewFeatures, _this)
            .off(constants_1.DispatchEvents.Reset, handleReset, _this);
    };
    (0, react_1.useEffect)(function () {
        if (testMode) {
            subscribe();
        }
        return unSubscribe;
    }, [featuresData]);
    if (!featuresData.length) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "ruby-widget" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "ruby-widget__wrapper" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "ruby-widget__features clickable" }, { children: (0, jsx_runtime_1.jsx)(Wrapper_1.default, { mobileWidth: MOBILE_WIDTH, features: localFeaturesData, redirectURL: redirectURL }) })) })) })));
};
exports.default = App;
